export const errors = {
  noEditorExist: 'Editor does not exist',
  B2BTokenRequestFailed:
    "Error trying to fetch partner's resources . Contact the administrator.",
  emailConfirmCodeIncorrect: 'Incorrect confirmation code from e-mail',
  authenticatorConfirmIncorrect: 'Incorrect code from the authenticator app',
  invalidPassword: 'Invalid password',
}
